import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle } from "components/ui/Card";
import { ErrorBoundary } from "components/ui/ErrorBoundary";
import Spinner from "components/ui/Spinner";
import { useAPI } from "components/hooks/useAPI";
import { useRoles } from "components/hooks/useRoles";
import { useHistoricAcademicRoles } from "components/hooks/useAcademicRoles";
import { ModernBlueButton } from "components/ui/Buttons";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Alumni+Homepage+Card
export function AlumniHomepageCard() {
  const { alumniFormer, faculty, staff } = useRoles();
  const { law: wasLaw } = useHistoricAcademicRoles();
  const displayCard = alumniFormer && !wasLaw && (faculty || staff);

  if (displayCard) {
    return (
      <ErrorBoundary title="Alumni Homepage">
        <AlumniHomepageCardUI />
      </ErrorBoundary>
    );
  }

  return null;
}

export function AlumniHomepageCardUI() {
  const api = useAPI();

  const [loadState, setLoadState] = useState("pending");
  const [alumData, setAlumData] = useState({});

  const {
    homepageLink,
    landingPageMessage: { descrlong: landingPageMessage = "" } = {},
  } = alumData;

  useEffect(() => {
    (async () => {
      try {
        const { success, data } = await api.alumniProfiles.index();

        if (success) {
          setAlumData(data);
          setLoadState("success");
        } else {
          setLoadState("error");
        }
      } catch (_error) {
        setLoadState("error");
      }
    })();
  }, []);

  return (
    <Card data-testid="alumni-homepage-card">
      <CardTitle>
        <h2>Alumni Homepage</h2>
      </CardTitle>
      <CardBody>
        {loadState === "pending" && <Spinner />}
        {loadState === "success" && (
          <>
            <p>{landingPageMessage}</p>
            <div style={{ textAlign: "center" }}>
              <ModernBlueButton
                title={homepageLink.title}
                onClick={() => api.signOut(homepageLink.url)}
              >
                {homepageLink.name}
              </ModernBlueButton>
            </div>
          </>
        )}
        {loadState === "error" && (
          <>The Alumni Homepage is not available right now.</>
        )}
      </CardBody>
    </Card>
  );
}
AlumniHomepageCard.displayName = "AlumniHomepageCard";
